import {
  SEL_DEFAULT_AREA_PLW,
  SEL_REPLACEMENT_STRATEGIES_PLW
} from '@/contentprofile/no_sel_composable'

const areasOfNeed = [
  {
    label: 'Pre-Academic Skills',
    value: 'Pre-Academic Skills',
    beta: false,
    dateAdded: new Date(2020, 2, 12) // March 12, 2020 (not Feb 12, 2020)
  },
  {
    label: 'Reading',
    value: 'Reading',
    iodSubject: true
  },
  {
    label: 'Writing',
    value: 'Writing',
    iodSubject: true
  },
  {
    label: 'Math',
    value: 'Math',
    iodSubject: true
  },
  {
    label: 'Alt Academics: Reading',
    value: 'Alt Academics: Reading',
    beta: false,
    dateAdded: new Date(2020, 2, 12)
  },
  {
    label: 'Alt Academics: Writing',
    value: 'Alt Academics: Writing',
    beta: false,
    dateAdded: new Date(2020, 10, 24)
  },
  {
    label: 'Alt Academics: Math',
    value: 'Alt Academics: Math',
    beta: false,
    dateAdded: new Date(2020, 2, 12)
  },
  {
    label: 'Executive Functioning',
    value: 'Executive Functioning',
  },
  {
    label: 'Behavior',
    value: 'Behavior',
    iodSubject: true
  },
  {
    label: 'Social and Emotional Learning',
    value: 'Social & Emotional Learning'
  },
  {
    label: 'Communication',
    value: 'Communication'
  },
  {
    label: 'Fine Motor Skills',
    value: 'Fine Motor Skills'
  },
  {
    label: 'Gross Motor Skills',
    value: 'Gross Motor Skills',
    dateAdded: new Date(2020, 7, 21) // August 21, 2020
  },
  {
    label: 'Functional and Life Skills',
    value: 'Functional'
  },
  {
    label: 'Transition',
    value: 'Transition',
    beta: false,
    dateAdded: new Date(2020, 2, 12)
  }
]

export function getAreasOfNeed(opts = { selBlocked: false, iodSubject: false }) {
  let areasToReturn = areasOfNeed.slice()
  if (opts && opts.selBlocked) {
    areasToReturn.find((area) => area.value === SEL_DEFAULT_AREA_PLW).label =
      SEL_REPLACEMENT_STRATEGIES_PLW
  }
  if (opts && opts.iodSubject) {
    areasToReturn = areasToReturn.filter((area) => area.iodSubject)
  }
  return areasToReturn
}
